import axios from 'axios'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Cookies from 'js-cookie'

axios.interceptors.request.use(
  (config) => {
    config.headers.imprintHash = Cookies.get('imprint')
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

export const loginReq = async (data) => {
  if (!Cookies.get('imprint')) {
    const errorObj = {
      data: {
        code: 'ERROR',
        text: 'Произошла ошибка, пожалуйста, попробуйте снова',
      },
    }
    const fingerPrint = await FingerprintJS.load()
    const { visitorId: imprintHash } = (await fingerPrint.get()) || {}
    Cookies.set('imprint', imprintHash)
    return Promise.resolve(errorObj)
  }

  return axios.post('/ajax/login/auth', data)
}

export const kafkaLog = async (data) => {
  if (!Cookies.get('imprint')) {
    const errorObj = {
      data: {
        code: 'ERROR',
      },
    }
    const fingerPrint = await FingerprintJS.load()
    const { visitorId: imprintHash } = (await fingerPrint.get()) || {}
    Cookies.set('imprint', imprintHash)
    return Promise.resolve(errorObj)
  }
  return axios.post('/api/metrics/v1/log', data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

// deprecated: WEB-5105
export const CookieApi = {
  imprint: (data, imprintHash) =>
    axios.post('/ajax/cookie/imprint', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        imprintHash,
      },
    }),
}

export const RecoveryApi = {
  getData: (type, params) =>
    axios.get(`/ajax/data/${type}${params ? `?${params}` : ''}`),
  stepPhone1: (data) =>
    axios.post('/ajax/account/recover_by_phone/step1', data),
  stepPhone2: (data) =>
    axios.post('/ajax/account/recover_by_phone/step2', data),
  stepPhone3: (data) =>
    axios.post('/ajax/account/recover_by_phone/step3', data),
  stepEmail1: (data) =>
    axios.post('/ajax/account/recover_by_email/step1', data),
  stepEmail2: (data) =>
    axios.post('/ajax/account/recover_by_email/step2', data),
  stepEmail3: (data) =>
    axios.post('/ajax/account/recover_by_email/step3', data),
}
